import { render } from "./events.vue?vue&type=template&id=217ab80d&scoped=true"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"

import "./events.vue?vue&type=style&index=0&id=217ab80d&lang=css&scoped=true"

import exportComponent from "/var/www/mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217ab80d"]])

export default __exports__